export default {
  delete: "Confirmer la suppression ?",
  deleteItem: "Confirmer la suppression de cet élément ?",
  deleteOrder: "Confirmer la suppression de cette commande ?",
  cancelOrder: "Confirmer l'annulation de cette commande ?",
  rejectOrder: "Confirmer le refus de cette commande ?",
  executeAction: "Confirmer cette action ?",
  actionItem: "Confirmer {action} pour cet élément ?",
  actionSelected: "Confirmer {action} pour la sélection ?",
  actionNamed: "Confirmer {action} ?",
};
